import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Box, Button, DialogContent, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import initStripe from 'services/Stripe'

import PaymentAPI from '../../../api/orbitV1/PaymentAPI'
export default function StripeQRForm({
  orgId,
  email,
  amountPayable,
  setDialogOpen,
  handleNext,
  handleBack,
  metaInfo,
  variant
}) {
  const [stripePromise, setStripePromise] = useState(null)
  const [options, setOptions] = useState(null)
  const [payIntentOpen, setPayIntentOpen] = useState(false)
  const navigate = useNavigate()

  // stripe public key
  useEffect(() => {
    initStripe().then((res) => {
      setStripePromise(res)
    })
  }, [])

  useEffect(() => {
    if (!payIntentOpen) {
      createPaymentIntent(orgId, amountPayable)
    }
  }, [])

  const createPaymentIntent = async (customerId, paymentAmount) => {
    try {
      const paymentIntent = await PaymentAPI.createPayInt({
        customerId,
        email,
        paymentAmount,
        orderNo: metaInfo.data.orderNo ?? '',
        billNo: metaInfo.data.billNo ?? '',
        pricePackage: {
          currency: 'sgd',
          value: paymentAmount,
          symbol: '$'
        },
        service: 'orbit',
        type: variant,
        paymentMethodTypes: ['paynow']
      })
      if (paymentIntent.data) {
        setOptions({
          // passing the client secret obtained in step 2
          clientSecret: paymentIntent.data.client_secret,
          // Fully customizable with appearance API.
          appearance: {
            theme: 'flat'
          }
        })
        setPayIntentOpen(true)
      }
    } catch (error) {
      toast.error('Error making payment. Please try again later!')
    }
  }

  const handleQRCode = async () => {
    const { paymentIntent, error: stripeError } =
      await stripePromise.confirmPayNowPayment(options.clientSecret, {})

    if (stripeError) {
      toast.error('Error loading QR code. Please try again later!')
    } else {
      try {
        if (paymentIntent.status === 'succeeded') {
          setDialogOpen(false)
          setPayIntentOpen(false)
          if (variant === 'onboarding') {
            navigate('/order-success')
          } else {
            handleNext()
          }
        } else if (paymentIntent.status === 'requires_action') {
          toast.error('PayNow payment did not go through. Please try again.')
        }
      } catch (error) {
        toast.error('Error updating order. Please try again later!')
      }
    }
  }

  return (
    <>
      <DialogContent
        sx={{
          justifyContent: 'center',
          display: 'flex'
        }}
      >
        {payIntentOpen && (
          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography>
              Click the button below to open the QR code for making PayNow
              payments
            </Typography>
            <Box>
              <Button
                sx={{ marginTop: '10px', marginRight: '10px' }}
                onClick={handleBack}
                data-cy='paymentBackBtn'
              >
                Back
              </Button>
              <Button
                sx={{ marginTop: '10px' }}
                variant='contained'
                onClick={handleQRCode}
                data-cy='scanQRBtn'
              >
                Click to scan QR code
              </Button>
            </Box>
          </Box>
        )}
      </DialogContent>
    </>
  )
}

StripeQRForm.propTypes = {
  orgId: PropTypes.string,
  email: PropTypes.string,
  amountPayable: PropTypes.number,
  setDialogOpen: PropTypes.func,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  metaInfo: PropTypes.object,
  variant: PropTypes.string
}
